import React from "react";

import CadastroPage from "./view/page";

export default (props) => {
	return <CadastroPage {...props} />;
};
